export default __webpack_public_path__ + "static/data-analysis-7b54627ad48c4cff84fa9e1a6a99019e.png";